const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const BASE_URL_ADMIN = process.env.REACT_APP_API_BASE_URL_ADMIN;
const WEBSOCKET_URL=process.env.WEBSOCKET_URL || "ws://3.107.84.167/";
export { BASE_URL , WEBSOCKET_URL, BASE_URL_ADMIN };
